/*eslint-disable */

import axios from 'axios';
import carousel from 'vue-owl-carousel';
import countries from '@/services/country.json'
import {
  mapGetters
} from 'vuex';
import toast from '@/services/toast';

const $ = window.jQuery = require('jquery'); 




export default {
  name: 'consulting-doctors-list',
  components: {
    carousel
  },
  props: [],
  data () {
    return {
      doctorConsultRequestData:null,
      doctorConsultRequestDataResults:[],
      countryList:[],
      consultDoctorInfoPopupState:false,
      consultDoctorInfoPopupData:null,
      confrimConsultRequestPopupState:false,
      confrimConsultRequestId:'',
      declineConsultRequestPopupState:false,
      declineConsultRequestId:'',
      doctorConsultPublicRequestData:null,
      doctorConsultPublicRequestDataResults:[],
      userFilterInfoPopupState:false,
      userFilterInfoPopupStateClass:false,
      userFilterInfoData:null
    }
  },
  computed: {
  ...mapGetters([
    'doctorConsultRequestGetters',
    'doctorConsultPublicRequestGetters'
  ]),
  getDoctorConsultRequestDataFun(){
   this.doctorConsultRequestData = this.$store.getters.doctorConsultRequestGetters.data
   return 
  },
  SetIntialStatus() {
    if(this.doctorConsultRequestData){
      this.doctorConsultRequestDataResults = this.doctorConsultRequestData.results
    }
    return;
  },
  getDoctorConsultPublicRequestDataFun(){
   this.doctorConsultPublicRequestData = this.$store.getters.doctorConsultPublicRequestGetters.data
   return 
  },
  SetIntialPublicStatus() {
    if(this.doctorConsultPublicRequestData){
      this.doctorConsultPublicRequestDataResults = this.doctorConsultPublicRequestData.results
    }
    return;
  },
  },
  mounted () {
    Object.keys(countries).map((key, index) => {
      this.countryList.push({
        name: countries[key].toLowerCase(),
        value: key.toLowerCase()
      })
    });
    this.countryList.sort((a, b) => (a.name > b.name) ? 1 : -1)
    this.getDoctorConsultRequestDataFun
    this.SetIntialStatus 
    this.getDoctorConsultPublicRequestDataFun
    this.SetIntialPublicStatus 
  },
  methods: {
    userFiltersInfoPopupMethod(data){
      this.userFilterInfoData = data
      $(window).scrollTop(0);
      this.userFilterInfoPopupState = true
      document.body.classList.add('body_right_scroll_remove')
      setTimeout(() => {
        this.userFilterInfoPopupStateClass = true
      }, 10);
    },
    clickedOutside() {
      this.userFilterInfoPopupStateClass = false
      setTimeout(() => {
        this.userFilterInfoPopupState = false
        document.body.classList.remove('body_right_scroll_remove')
        this.userFilterInfoData = ''
      }, 600);
    },
    getCountryFlag: function(countryCode, type) {
      if (countryCode == null) {
        countryCode = ''
      }
      let countryName = countryCode.toLowerCase()
      let country = this.countryList.filter(item => (item.value) == (countryName) || (item.name) == (countryName));
      if (country && country.length > 0) {
        country = country[0]
        if (type == 'flag') {
          country = `https://567c9b4f06e54c9c9229fe11191a6432.s3.ca-central-1.amazonaws.com/media/shiny/${country.value}.png`
        } else {
          country = country.name
        }
      } else {
        country = ''
      }
      return country;
    },
    getConsultDoctorRequestListAgainMethod(){
      this.$store.dispatch('getConsultDoctorRequestListFunc')
      this.$store.dispatch('getConsultDoctorRequestPublicListFunc')
    },
    consultDoctorInfoPopupShowMethod(data){
      this.consultDoctorInfoPopupState = true
      this.consultDoctorInfoPopupData = data
      $("body").addClass("body_right_scroll_remove");
    },
    consultDoctorInfoPopupHideMethod(){
      this.consultDoctorInfoPopupState = false;
      $("body").removeClass("body_right_scroll_remove");
    },
    consultRequestPopupMethod(id){
      this.confrimConsultRequestId = id
      this.confrimConsultRequestPopupState = true
      $("body").addClass("body_right_scroll_remove");
    },
    closeConsultRequestPopupMethod(){
      this.confrimConsultRequestId = ''
      this.confrimConsultRequestPopupState = false
      $("body").removeClass("body_right_scroll_remove");
    },
    closeConsultDeclinedPopupMethod(){
      this.declineConsultRequestId = ''
      this.declineConsultRequestPopupState = false
      $("body").removeClass("body_right_scroll_remove");
    },
    declinedConsultRequestPopupMethod(id){
      this.declineConsultRequestId = id
      this.declineConsultRequestPopupState = true
    },
    confirmedConsultDeclinedPopupMethod(){
      let data ={
        is_active : false
      }
      this.$store.dispatch('updateConsultDoctorRequestListFunc', {data:{id:this.declineConsultRequestId, data: data}}).then((res) => {
        toast.success(res.data.msg);
        this.closeConsultDeclinedPopupMethod();
        this.getConsultDoctorRequestListAgainMethod();
      }).catch((err) => {
        toast.error( err.data.user_msg || err.data.msg);
      })
    },
    confirmedConsultRequestPopupMethod(){
      let data ={
        is_active : true
      }
      this.$store.dispatch('updateConsultDoctorRequestListFunc', {data:{id:this.confrimConsultRequestId, data: data}}).then((res) => {
        toast.success(res.data.msg);
        this.closeConsultRequestPopupMethod();
        this.getConsultDoctorRequestListAgainMethod();
      }).catch((err) => {
        toast.error( err.data.user_msg || err.data.msg);
      })
    },
  },
  watch:{
    getDoctorConsultRequestDataFun(){
      return this.$store.getters.doctorConsultRequestGetters;
    },
    SetIntialStatus() {
      if(this.doctorConsultRequestData){
        this.doctorConsultRequestDataResults = this.doctorConsultRequestData.results
      }
      return;
    },
    getDoctorConsultPublicRequestDataFun(){
      return this.$store.getters.doctorConsultPublicRequestGetters;
    },
    SetIntialPublicStatus() {
      if(this.doctorConsultPublicRequestData){
        this.doctorConsultPublicRequestDataResults = this.doctorConsultPublicRequestData.results
      }
      return;
    },
  },
  beforeCreate: function() {
  },
  beforeRouteLeave: function(to, from, next) {
    $("body").removeClass("body_right_scroll_remove");
    next();
  },
}